<div class="d-flex flex-wrap gap-2 justify-content-around amt-2">
    <div class="d-flex flex-column col-5 gap-3 justify-content-center align-items-center parent p-4" *ngFor="let c of tableCount">
        <div class="line loading-shimmer mt-2 col-12" *ngFor = "let x of lineCount"></div>
    </div>
</div>
